module.exports = __webpack_public_path__ + "static/claxton-88c1aadc2a06d8f5722aebb7ad2021d7.jpeg";